import { LeftCircleOutlined } from "@ant-design/icons";
import SplitViewStyles from "./split-view-styles";

const MobileSidebar = ({ sidebar, showSidebar, onToggle }) => {
  const _onToggle = () => {
    if (onToggle) onToggle();
  };

  return (
    <>
      <div
        className={`sidebar-mobile ${
          !showSidebar ? "sidebar-mobile-closed" : ""
        }`}
      >
        {sidebar}
      </div>
      <div
        onClick={(evt) => _onToggle()}
        className="collapse-icon"
        data-cy="filterCollapse"
      >
        <LeftCircleOutlined
          className={`${
            !showSidebar ? "collapse-closed-mobile" : "collapse-open-mobile"
          }`}
        />
      </div>
      <SplitViewStyles />
    </>
  );
};

export default MobileSidebar;
